import React from 'react';
import { container } from 'tsyringe';
import { TournamentsService } from '@base/features/tournaments/model/interfaces';
import FilteredDataTable from '@base/ui/components/filteredDataTable';
import { tourStatisticsCols } from './tournamentStatisticsColumns';
import { RangeValue } from '@ui-kit/components/rangePicker';
import Empty from '@ui-kit/components/empty';
import { ReactComponent as NoTournaments } from '@base/assets/images/no_tournaments.svg';
import { t } from '@base/utils/helpers';

export default function TournamentStatistics() {
  const tournamentsService: TournamentsService =
    container.resolve('tournamentsService');
  return (
    <FilteredDataTable
      getData={(range?: RangeValue) =>
        tournamentsService.getTournamentsStatistics(range)
      }
      getTableData={(data) => data.tourneys}
      columns={tourStatisticsCols}
      rangePickerTitle={t('completed_tournaments')}
      empty={
        <Empty
          icon={<NoTournaments height="124px" width="144px" />}
          style={{ margin: '100px' }}
        >
          {t('no_completed_tournaments')}
        </Empty>
      }
      tableStyle={{ maxHeight: '400px' }}
    />
  );
}
